var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.usingV2Captcha && !_vm.forceHide),expression:"usingV2Captcha && !forceHide"}],attrs:{"id":"v2_captcha"}})}
var staticRenderFns = []

export { render, staticRenderFns }